import React, { useState, useContext } from 'react';
import Form from './Form';
import { PublicPasswordContext } from '../../context/PublicPasswordContext';

const Restore = () => {
    const [isUpdated, setIsUpdated] = useState(false);
    const publicPasswordContext = useContext(PublicPasswordContext);

    const RestoredText = () => {
        setTimeout(() => window.location.assign('http://' + publicPasswordContext.organizationData.externalFormRedirectUrl), 5000);
        return (
            <div>
                <div className="row mt-2">
                    <div className="col-10 offset-1 text-center">
                        <span className="paragraph-regular-18">
                            Återställningen av ditt konto lyckades, du kan nu logga in med ditt nya lösenord.
                        </span>
                        <br />
                        <br />
                        <span className="paragraph-regular-18">
                            Du kommer automatiskt att bli skickad till {publicPasswordContext.organizationData.externalFormRedirectUrl}
                        </span>
                    </div>
                </div>
            </div>
        );
    }

    const Info = () => {
        return (
            <div className="row mt-2">
                <div className="col-10 offset-1 text-center">
                    <span className="paragraph-regular-18">Du kan återställa ditt konto genom att välja ett nytt lösenord</span>
                </div>
            </div>
        );
    }

    return (
        <div>
            <div className="row mt-5">
                <div className="col-12 text-center">
                    <h2>Återställ ditt konto</h2>
                </div>
            </div>
            {isUpdated ? <RestoredText /> : <div><Info /><br /><Form setIsUpdated={setIsUpdated} /></div>}
        </div>
    );
}

export default Restore;